import React, { useEffect, useState } from 'react';

// Small modal form to create a Grupo
export default function FormularioGrupo({ onClose, onCreated, apiCall }) {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    return () => {
      try { if (preview) URL.revokeObjectURL(preview); } catch {}
    };
  }, [preview]);

  const onFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    setFile(f);
    try { setPreview(URL.createObjectURL(f)); } catch {}
    e.target.value = '';
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const r = reader.result || '';
      const s = typeof r === 'string' ? r : '';
      const base64 = s.includes(',') ? s.split(',')[1] : s;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!nome || nome.trim().length === 0) { setError('Nome do grupo é obrigatório.'); return; }
    setLoading(true);
    try {
      let fotoBase64 = null;
      if (file) fotoBase64 = await fileToBase64(file);

      const payload = { NomeGrupo: nome, Descricao: descricao || null, DonoGrupo: 0, FotoGrupo: fotoBase64 };
      const created = await apiCall('Grupo', 'POST', payload);
      
      // Disparar evento para atualizar lista de grupos no sidebar
      try { window.dispatchEvent(new CustomEvent('groupsChanged')); } catch {}
      
      if (typeof onCreated === 'function') onCreated(created);
      onClose && onClose();
    } catch (err) {
      console.error('Erro criando grupo', err);
      setError(err.message || 'Erro ao criar grupo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Criar Grupo</h3>
          <button className="icon-btn" onClick={onClose} aria-label="Fechar" style={{ fontSize: 20, background: 'none', border: 'none', cursor: 'pointer', color: 'rgb(235, 133, 0)' }}>×</button>
        </div>

        <form onSubmit={handleSubmit} style={{ marginTop: 12 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div className="group-photo-circle">
              {preview ? <img src={preview} alt="foto" /> : <div style={{ color: '#999', fontSize: 12 }}>Sem foto</div>}
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 700 }}>Foto do Grupo</label>
              <input type="file" accept="image/*" onChange={onFileChange} />
              <div style={{ marginTop: 6, fontSize: 12, color: '#666' }}>A foto aparecerá encaixada dentro do círculo acima.</div>
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 700 }}>Nome do Grupo</label>
            <input className="form-input" value={nome} onChange={e => setNome(e.target.value)} placeholder="Nome do grupo" />
          </div>

          <div style={{ marginTop: 12 }}>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 700 }}>Descrição</label>
            <textarea className="form-input" value={descricao} onChange={e => setDescricao(e.target.value)} placeholder="Descrição do grupo" />
          </div>

          {error && <div style={{ color: '#d32f2f', marginTop: 10 }}>{error}</div>}

          <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose} className="button-create" style={{ background: '#fff', color: 'rgb(235, 133, 0)', border: '1px solid rgb(235, 133, 0)' }}>Cancelar</button>
            <button type="submit" className="button-create" disabled={loading}>{loading ? 'Criando...' : 'Criar Grupo'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
